<template>
  <div class="actions" :class="{selected: selected}">
    <div class="action turn-in-review">Turn In Assignment</div>
    <br>
    <div class="action view-on-amazon">View On Amazon</div>
    <br>
    <div class="action download-manuscript">Download Manuscript</div>
  </div>
</template>

<script>
export default {
  name: "Actions",
  props: ["assignment"],
  data: function() {
    return {
      book: this.assignment.book
    };
  },
  computed: {
    imageUrl: function() {
      return process.env.VUE_APP_BOOK_IMAGES_PATH + this.book.id + ".jpg";
    }
  },
  created() {
    // console.log("assignment", this.assignment);
  }
};
</script>

<style lang="scss" scoped>
.actions {
  padding: 12px;
  padding-top: 18px;
  text-align: left;
}

.action {
  margin-top: 12px;
}

.turn-in-review {
  background: lighten(#c8e6c9, 5%);
  color: #43a047;
}

.download-manuscript {
  background: #daedff;
  color: #2196f3;
}
</style>


